import React, { ChangeEvent, FC, useState } from 'react';
import { OutlinedInput, InputAdornment, IconButton, Button, Checkbox, InputLabel, FormControlLabel } from '@mui/material';
import AuthorsListContent from './AuthorsListContent/AuthorsListContent';
import { useHistory } from 'react-router-dom';
import { Clear } from '@mui/icons-material';
import { StyledFormControl } from '@components/UI/styled';
import { useEditorsQuery, useCreateAuthorMutation } from './gql/authors.generated';
import {AUTHORS_LIST} from './AuthorsList.consts'
import {
    SearchWrapper,
    CompactSelect,
    CompactMenuItem
} from './AuthorsList.styles'


const AuthorsList: FC = () => {
    const [searchString, setSearchString] = useState('');
    const [selectedEditor, setSelectedEditor] = useState<string | null>(null);
    const [status, setStatus] = useState(false);

    const { data: editorsData, loading: editorsLoading } = useEditorsQuery();

    const [createAuthor, { loading: createAuthorLoading }] = useCreateAuthorMutation();

    const history = useHistory();

    const handleEditorChange = (event: ChangeEvent<{ value: unknown }>) => {
        setSelectedEditor(event.target.value as string);
    };

    const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
        setStatus(event.target.checked);
    };

    const handleCreateAuthor = async () => {
        try {
            const response = await createAuthor({
                variables: {
                    data: {
                    },
                },
            });

            const newAuthorUid = response.data?.createAuthor?.author?.uid;
            if (newAuthorUid) {
                history.push(`/author/editor/${newAuthorUid}`);
            } else {
                console.error('UID автора не получен в ответе мутации', error);
            }
        } catch (error) {
            console.error('Ошибка при создании автора:', error);
        }
    };

    return (
        <>
            <SearchWrapper>
                <StyledFormControl style={{ margin: '16px 24px 8px 0', width: '300px' }}>
                    <InputLabel htmlFor='header-search-input'>{AUTHORS_LIST.searchAuthor}</InputLabel>
                    <OutlinedInput
                        id="outlined-basic"
                        value={searchString}
                        label={AUTHORS_LIST.searchAuthor}
                        onChange={e => setSearchString(e.target.value)}
                        endAdornment={
                            <InputAdornment position="end">
                                {searchString && (
                                    <IconButton edge="end" size="small" onClick={() => setSearchString('')}>
                                        <Clear fontSize="small" />
                                    </IconButton>
                                )}
                            </InputAdornment>
                        }
                    />
                </StyledFormControl>

                <StyledFormControl style={{ margin: '16px 24px 8px 0', width: '300px' }}>
                    <InputLabel id="select-label" style={{ fontSize: '14px' }}> {AUTHORS_LIST.searchEditor}</InputLabel>
                    <CompactSelect
                        label={AUTHORS_LIST.searchEditor}
                        onChange={handleEditorChange}
                        value={selectedEditor || ''}
                        disabled={editorsLoading}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    maxHeight: '200px',
                                },
                            },
                        }}
                    >
                        <CompactMenuItem value="">
                            <em>{AUTHORS_LIST.allEditors}</em>
                        </CompactMenuItem>
                        {editorsData?.editors?.map(editor => (
                            <CompactMenuItem key={editor.uid} value={editor.uid}>
                                {editor.name}
                            </CompactMenuItem>
                        ))}
                    </CompactSelect>
                </StyledFormControl>

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={status}
                            onChange={handleCheckboxChange}
                            color="primary"
                        />
                    }
                    label={AUTHORS_LIST.searchIsFared}
                    style={{ margin: '16px 16px 8px 0' }}
                />
            </SearchWrapper>

            <AuthorsListContent
                status={status}
                search={searchString}
                selectedEditor={selectedEditor}
            />
        </>
    );
};

export default AuthorsList;